import { SET_CURRENT_FOOD_COURT_DETAILS } from "../actions";

export default function storeFoodCourtDetails(payload) {
  return {
    type: SET_CURRENT_FOOD_COURT_DETAILS,
    payload
  };
}



// WEBPACK FOOTER //
// ./src/store/actionCreators/currentFoodCourtDetails.js